import * as React from 'react'
import { ShellContainer, ShellBody, MainContent } from './styles'

interface AppShellProps {
  children: React.ReactNode
}

/**
 * AppShell — persistent authenticated layout wrapper.
 *
 * Rendered only for logged-in users (app.tsx gates on `user`).  Provides:
 *   • Responsive flex body for route content
 *   • Global header/profile/organization navigation owned outside the shell
 */
export const AppShell: React.FC<AppShellProps> = ({ children }) => {
  return (
    <ShellContainer>
      <ShellBody>
        <MainContent>
          {children}
        </MainContent>
      </ShellBody>
    </ShellContainer>
  )
}
